import React from "react";

/**
 * Tabla DS — wrapper liviano que aplica chrome Kronaly (header eyebrow,
 * row 12px padding, hover subtle). El consumidor pasa <thead>/<tbody>
 * con `<tr>`/`<th>`/`<td>` nativos.
 *
 * En mobile el contenedor permite scroll horizontal con momentum
 * (-webkit-overflow-scrolling: touch) — preferimos no colapsar la
 * tabla a cards por defecto, porque cada caller puede tener un
 * layout específico. Si una tabla resulta cómica en mobile, el
 * caller debería ofrecer una vista alternativa.
 */
export function Table({ children, dense = false, style }) {
  return (
    <div
      style={{
        background: "var(--kr-bg-surface)",
        border: "1px solid var(--kr-border)",
        borderRadius: "var(--kr-radius-md)",
        overflowX: "auto",
        overflowY: "hidden",
        WebkitOverflowScrolling: "touch",
        ...(style || {}),
      }}
    >
      <table
        className={`kr-table${dense ? " kr-table-dense" : ""}`}
        style={{
          width: "100%",
          minWidth: "max-content",
          borderCollapse: "separate",
          borderSpacing: 0,
          fontSize: 13,
          color: "var(--kr-fg-primary)",
        }}
      >
        {children}
      </table>
    </div>
  );
}

export default Table;
